module.exports = __webpack_public_path__ + "static/img/WarmPlate (16).a062e483.png";